module.exports = __webpack_public_path__ + "img/logo_asian_post.b47a81db.png";